import styled from "styled-components";
import { black } from "../../global/colours";
import { weight as fontWeight } from "../../global/fonts";

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 40px;
`;

export const StyledListItem = styled.li`
  font-size: 10px;
  font-weight: 400!important;
`;

const BaseTextStyles = `
  color: ${black[100]};
  display: inline-block;
  margin-bottom: 4px;
  text-transform: uppercase;
`;

export const ListText = styled.span`
  ${BaseTextStyles}
`;
